<template>
    <div>
        <div><span class="link" v-on:click="toggleCollapse()">Задача: {{id}}</span><base-button size="sm" class="pull-right" type="danger" simple v-on:click="remove()">X</base-button></div>
        <div v-if="apiData.id">Модель {{  apiData.query_model }}</div>
        <template v-if="!collapsed">
            <div v-if="apiData.id">
            <br/>Запрос: <span v-if="!showQuery" class="link" v-on:click="onShowQuery(true)">Показать</span><span v-else><span class="link" v-on:click="onShowQuery(false)">Скрыть</span> {{ apiData.prompt }} {{ apiData.options }}</span></div>
            <div v-if="apiData.status==0">Ожидает в очереди на {{ apiData.pos }} позиции</div>
            <div v-else-if="apiData.status==1">В работе у {{ apiData.workerId }} с {{ apiData.UpdDate }}</div>
            <div v-else>
                Ответ:
                <div class="prewrap" v-if="apiData.answer">
                    {{ apiData.answer }}
                </div>
                <div class="prewrap code" v-if="apiData.parsed && apiData.parsed.json">
                    {{ apiData.parsed.json }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data(){
        return {
            apiData:{status:0},
            timer:null,
            showQuery:false, 
            collapsed:false,
        }
    },
    props:{
        id:{
            type:Number
        }
    },
    methods:{
        remove(){
            this.$emit('close',this.id);
        },
        onShowQuery(v){
            this.showQuery=v;
        },
        toggleCollapse(){
            this.collapsed=!this.collapsed;
            // console.log(this.collapsed);
        },  
        async loadData(){
            if(!this.id) return;
            let data = await this.$GVO.Api.AI.queue({flt:{id:this.id}});
            if(data.success==true){
                try{
                    if(data.data.answer_raw)
                        data.data.parsed=JSON.parse(data.data.answer_raw);
                }catch(e){
                    console.error(e,{'raw':data.data.answer_raw})
                }
                this.apiData=data.data;
                if(this.apiData.status==0){
                    this.timer = setTimeout(this.loadData, 15000);
                }else if(this.apiData.status==1){
                    this.timer = setTimeout(this.loadData, 5000);
                }
            }
        }
    },
    mounted(){
        this.loadData();
    },
    destroyed(){
        // console.log('destr');
    },
    beforeDestroy(){
        // console.log('bef');
        clearTimeout(this.timer);
    }
}
</script>

<style lang="scss" scoped>
    .link{cursor:pointer; color:blue;}
    .code{
        font-family: monospace;
    
    }
</style>